import * as React from 'react'
import { Virtualizer } from '@tanstack/react-virtual'
import { Table } from '@tanstack/react-table'

export interface ApiRef<T> {
  tableInstance: Table<T>
  virtualizer: Virtualizer<HTMLElement, Element>
}

export const useSelectAdvanceApiRef = <T,>() =>
  React.useRef({}) as React.MutableRefObject<ApiRef<T>>
